import React from 'react';
import Navbar from './Navbar';
import ContactSection from './ContactSection';
import FaqSection from './FaqSection';
import Footer from './Footer';

const ContactPage = ({ onNavigate }) => {
  return (
    <div className="contact-page-container">
      {/* Top Navbar */}
      <div className="contact-nav-header-wrap">
        <Navbar isVisible={true} currentPage="contact" onNavigate={onNavigate} />
      </div>

      {/* Main Contact Section */}
      <ContactSection />

      {/* Frequently Asked Questions Section */}
      <FaqSection />

      {/* Footer Section */}
      <Footer onNavigate={onNavigate} />
    </div>
  );
};

export default ContactPage;
